export const LS_LOGIN_EMAIL = 'emailForSignIn';